// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMTabs.tsx — PropelMapper in-screen tabs.
//
// A tab strip (role="tablist") + optional panels, controlled or uncontrolled.
// Two variants: "underline" (default — Pine indicator under the active label)
// and "pill" (soft primary-surface fill, the segmented look for compact toolbars).
//
// System rules honored: active = Pine green (--pm-primary / --pm-primary-dark),
// the role the system assigns to tabs; inactive = fg-2; focus uses --pm-focus-ring;
// full keyboard model (Arrow/Home/End roving focus, automatic or manual activation);
// counts reuse the badge token surfaces.
//
//   <PMTabs
//     tabs={[{ id:"feed", label:"Feed" }, { id:"visits", label:"Visits", count:2 }]}
//     value={tab} onChange={setTab}
//     panels={{ feed: <Feed/>, visits: <Visits/> }} />

const PMTABS_CSS = `
.pmtabs{font-family:var(--pm-font-sans)}
.pmtabs-list{display:flex;align-items:stretch;gap:2px;list-style:none;margin:0;padding:0}
.pmtabs--underline .pmtabs-list{gap:6px;border-bottom:1px solid var(--pm-border);}
.pmtab{appearance:none;background:transparent;border:none;cursor:pointer;font-family:inherit;color:var(--pm-fg-2);display:inline-flex;align-items:center;gap:8px;white-space:nowrap;transition:color .12s,background .12s;border-radius:var(--pm-radius-m,8px)}
.pmtab:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmtab[aria-disabled="true"]{opacity:.42;cursor:default}

/* underline */
.pmtabs--underline .pmtab{font:600 14px/1 var(--pm-font-sans);padding:12px 8px;border-radius:0;border-bottom:2px solid transparent;margin-bottom:-1px}
.pmtabs--underline.pmtabs--sm .pmtab{font-size:13px;padding:9px 6px}
.pmtabs--underline .pmtab:hover:not([aria-disabled="true"]){color:var(--pm-fg-1)}
.pmtabs--underline .pmtab[aria-selected="true"]{color:var(--pm-primary-dark);border-bottom-color:var(--pm-primary)}

/* pill */
.pmtabs--pill .pmtabs-list{background:var(--pm-surface-variant);border-radius:var(--pm-radius-pill,999px);padding:3px;gap:2px;display:inline-flex}
.pmtabs--pill .pmtab{font:600 13px/1 var(--pm-font-sans);padding:8px 15px;border-radius:var(--pm-radius-pill,999px)}
.pmtabs--pill.pmtabs--sm .pmtab{font-size:12px;padding:6px 12px}
.pmtabs--pill .pmtab:hover:not([aria-disabled="true"]):not([aria-selected="true"]){color:var(--pm-fg-1);background:color-mix(in srgb,var(--pm-primary) 6%,transparent)}
.pmtabs--pill .pmtab[aria-selected="true"]{background:var(--pm-surface);color:var(--pm-primary-dark);box-shadow:var(--pm-shadow-xs)}

.pmtab-ico{display:inline-flex;flex:0 0 auto}
.pmtab-count{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:999px;font:700 11px/1 var(--pm-font-sans);background:var(--pm-surface-variant);color:var(--pm-fg-2)}
.pmtab[aria-selected="true"] .pmtab-count{background:var(--pm-primary-surface);color:var(--pm-primary-dark)}
.pmtabs--pill .pmtab[aria-selected="true"] .pmtab-count{background:var(--pm-primary-surface)}

.pmtab-panel{padding-top:18px}
.pmtab-panel:focus-visible{outline:none;box-shadow:var(--pm-focus-ring);border-radius:var(--pm-radius-m,8px)}
`;

function pmtabsEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmtabs-css")) return;
  const s = document.createElement("style"); s.id = "pmtabs-css"; s.textContent = PMTABS_CSS;
  document.head.appendChild(s);
}

let pmtabsSeq = 0;

export function PMTabs({
  tabs = [],
  value,
  defaultValue,
  onChange,
  variant = "underline",
  size = "md",
  panels = null,
  activateOnFocus = true,
  "aria-label": ariaLabel,
  className = "",
  style = {},
}: any) {
  pmtabsEnsureCSS();
  const isControlled = value !== undefined;
  const firstId = tabs.length ? tabs[0].id : undefined;
  const [internal, setInternal] = (React as any).useState(defaultValue != null ? defaultValue : firstId);
  const current = isControlled ? value : internal;
  const refs = (React as any).useRef({});
  const baseId = (React as any).useRef("pmtabs-" + (++pmtabsSeq)).current;

  const select = (id: any) => { if (!isControlled) setInternal(id); if (onChange) onChange(id); };

  const enabledIds = tabs.filter((t: any) => !t.disabled).map((t: any) => t.id);
  const onKeyDown = (e: any) => {
    if (!enabledIds.length) return;
    let idx = enabledIds.indexOf(current);
    if (idx < 0) idx = 0;
    let next;
    if (e.key === "ArrowRight" || e.key === "ArrowDown") next = enabledIds[(idx + 1) % enabledIds.length];
    else if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = enabledIds[(idx - 1 + enabledIds.length) % enabledIds.length];
    else if (e.key === "Home") next = enabledIds[0];
    else if (e.key === "End") next = enabledIds[enabledIds.length - 1];
    else return;
    e.preventDefault();
    const el = refs.current[next];
    if (el) el.focus();
    if (activateOnFocus) select(next);
  };

  const cls = "pmtabs pmtabs--" + variant + (size === "sm" ? " pmtabs--sm" : "") + (className ? " " + className : "");

  return (
    <div className={cls} style={style}>
      <div className="pmtabs-list" role="tablist" aria-label={ariaLabel} aria-orientation="horizontal">
        {tabs.map((t: any) => {
          const selected = t.id === current;
          return (
            <button
              key={t.id}
              ref={(el: any) => { refs.current[t.id] = el; }}
              type="button"
              role="tab"
              id={baseId + "-tab-" + t.id}
              aria-selected={selected}
              aria-controls={panels ? baseId + "-panel-" + t.id : undefined}
              aria-disabled={t.disabled ? true : undefined}
              tabIndex={selected ? 0 : -1}
              className="pmtab"
              onClick={() => { if (!t.disabled) select(t.id); }}
              onKeyDown={onKeyDown}
            >
              {t.icon ? <span className="pmtab-ico" aria-hidden="true">{t.icon}</span> : null}
              <span>{t.label}</span>
              {t.count != null ? <span className="pmtab-count">{t.count}</span> : null}
            </button>
          );
        })}
      </div>
      {panels && current != null && panels[current] !== undefined ? (
        <div
          className="pmtab-panel"
          role="tabpanel"
          id={baseId + "-panel-" + current}
          aria-labelledby={baseId + "-tab-" + current}
          tabIndex={0}
        >
          {panels[current]}
        </div>
      ) : null}
    </div>
  );
}
